// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getJabatan, insertJabatan, jabatanSelector, updateJabatan} from './jabatanSlice';

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const JabatanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const jabatan = useSelector(
        jabatanSelector
    );

    useEffect(() => {
        dispatch(getJabatan({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && jabatan.isGetSuccess && !jabatan.isGetFetching) {
            let calc = jabatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = jabatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && jabatan.isGetSuccess && !jabatan.isGetFetching) {
            let calc = jabatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = jabatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!jabatan?.isGetFetching && jabatan.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = jabatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = jabatan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getJabatan({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (jabatan.isGetSuccess) {
                alertService.success(jabatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getJabatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (jabatan.isUpdateSuccess) {
                alertService.success(jabatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateJabatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetJabatan(params) {
    //   return dispatch(getJabatan(params));
    // }

    function handleInsertJabatan(param) {
        setInsertFetch(true);
        const params = {
            namaJabatan: param.inputOneValue,
            jabatanID: param.dropdownOneValue,
        };
        dispatch(insertJabatan(params));
    }

    function handleUpdateJabatan(param) {
        setUpdateFetch(true);

        const params = {
            namaJabatan: param.inputOneValue,
            idJabatan: currentData.JabatanID,
            status: param.status,
        };
        dispatch(updateJabatan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getJabatan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getJabatan(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (jabatan.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? jabatan.count : newCount,
            search: search,
        }
        dispatch(getJabatan(params));

        setPage(1);
        setCount((newCount === "-1") ? jabatan.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Jabatan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Jabatan"
                                tableData={jabatan.data}
                                colOneTitle="ID"
                                colOneData="JabatanID"
                                colTwoTitle="Nama Jabatan"
                                colTwoData="NamaJabatan"
                                status="Status"

                                fetching={jabatan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Jabatan"
                        inputOneTitle="Nama Jabatan"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertJabatan}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.JabatanID}
                        modal={handleModal}
                        modalTitle="Ubah Jabatan"
                        inputOneTitle="Nama Jabatan"
                        inputOneValue={currentData.NamaJabatan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateJabatan}
                    />
                }
            </div>

        )
    }

}


export default JabatanPage;